import PropTypes from 'prop-types'

const MySimpleHeader = ({ text }) => {
  return (
    <header className="bg-white shadow">
      <div className="mx-auto flex max-w-full justify-between px-4 py-6 sm:px-6 lg:px-8">
        <h1 className="font-medium capitalize text-gray-900 sm:text-sm lg:text-2xl">
          {text}
        </h1>
      </div>
    </header>
  )
}

export default MySimpleHeader

MySimpleHeader.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
}
